document.addEventListener("DOMContentLoaded", function() {
    const sectionClose = document.getElementById('section-close');
    if (sectionClose) {
        sectionClose.addEventListener('click', () => {
            let section = document.getElementById('announcement-top');
            section.remove();
            let now = new Date();
            let time = now.getTime();
            let expireTime = time + 172800;//two days
            now.setTime(expireTime);
            document.cookie = "section=true; path=/; expires="+now.toUTCString();
        });
    }

    if (document.cookie.split(';').filter((item) => item.trim().startsWith('section=')).length) {
        let section = document.getElementById('announcement-top');
        section.classList.add('close');
    } else {
        let section = document.getElementById('announcement-top');
        section.classList.remove('close');
    }

    const pathNav = location.pathname;

    if (pathNav){
        let navItem = document.querySelector('.sliderow a[href="'+ pathNav +'"]');
        if (navItem){
            navItem.parentNode.classList.add('active');
        }
    }

    const cookiesAccept = document.querySelector('[data-confirm-cookies]');
    if (cookiesAccept) {
        cookiesAccept.addEventListener('click', () => {
            let now = new Date();
            let time = now.getTime();
            let expireTime = time + 86400*30;
            now.setTime(expireTime);
            document.cookie = "close=popup; path=/; expires="+now.toUTCString();
        });
    }
    if (document.cookie.split(';').filter((item) => item.trim().startsWith('close=')).length) {
        let cookiePopup = document.querySelector('[data-cookie-name]');
        cookiePopup.classList.add('close');
    }

    const mainVideo = document.querySelector('.section-video');
    if (mainVideo){
        let section = document.getElementById('announcement-top');
        if (section){
            section.classList.add('hide');
        }
    }

    window.addEventListener('scroll', function(e) {

        const header =  document.querySelector('.header__wrapper');

        if(header){
            let attr = header.getAttribute('data-header-transparent');

            if(attr != true){
                let section = document.getElementById('announcement-top');
                if (section){
                    section.classList.remove('hide');
                }
            } else if (attr == true) {
                let section = document.getElementById('announcement-top');
                if (section){
                    section.classList.add('hide');
                }
            }

            if (window.scrollY < 40){
                let section = document.getElementById('announcement-top');
                if (section){
                    section.classList.add('hide');
                }
            }
        }

    });

});

const video_autoplay = document.querySelectorAll('.deferred-media.hide-mobile');
function remove_autoplay(){
    if(document.documentElement.clientWidth < 749){
        video_autoplay.forEach(item =>{
            item.querySelector('video').setAttribute('autoplay','false')
            item.querySelector('video').setAttribute('preload','none')
            item.querySelector('video').pause();
        })
    }else{
        video_autoplay.forEach(item =>{
        item.querySelector('video').setAttribute('autoplay','autoplay')
        item.querySelector('video').removeAttribute('preload')
        item.querySelector('video').play();
        })
    }
}
remove_autoplay()
window.addEventListener('resize', function (){
    remove_autoplay()
});
